export default __webpack_public_path__ + "static/media/ROZGWIAZDA.6ca33f91.png";